import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';

import { utilities } from '~/common';

import { CourseImageOverlay, CoursePreviewCardWrapper, MediaPlayIcon, PlayArrow } from './elements';

const { truncate } = utilities;

interface CoursePreviewItemType {
  image: string;
  subtitle: string;
  video: string;
  title: string;
}
export interface CoursePreviewProps {
  title?: string;
  designType?: string;
  data: CoursePreviewItemType[];
}

export const CoursePreviewCard: React.FC<
  PropsWithChildren<{ item: CoursePreviewItemType; onClick: () => void }>
> = ({ item, onClick }) => {
  return (
    <CoursePreviewCardWrapper
      maxWidth={{ xs: '250px', sm: '320px', md: '400px', lg: '450px' }}
      width="100%"
      style={{ margin: '0 auto 40px', borderRadius: '4px' }}
      onClick={onClick}
    >
      <Box
        height={{ xs: '200px', md: '280px', lg: '300px' }}
        width="100%"
        style={{ position: 'relative' }}
      >
        <CardMedia
          component="img"
          height="100%"
          width="100%"
          image={item.image}
          title="Course Preview"
        />
        <CourseImageOverlay>
          <MediaPlayIcon>
            <PlayArrow />
          </MediaPlayIcon>
        </CourseImageOverlay>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        flex="1"
        alignItems="center"
        style={{ backgroundColor: 'white' }}
        py="12px"
        height="75px"
      >
        <Box fontWeight="bold" textAlign="center">
          {truncate(item.title, 52, '...')}
        </Box>
        <Box fontSize="14px">{item.subtitle}</Box>
      </Box>
    </CoursePreviewCardWrapper>
  );
};
